import { request } from "utils/request";
import { AxiosPromise } from "axios";


export const businessTypeApi = {
    findAll: (params?: any): AxiosPromise<any> => request({
        url: '/v1/admin/businessType',
        params
    }),
    create: (data: any): AxiosPromise<any> => request({
        url: '/v1/admin/businessType',
        data,
        method: 'post'
    }),
    update: (id: number, data: any): AxiosPromise<any> => request({
        url: `/v1/admin/businessType/${id}`,
        method: 'patch',
        data
    }),
    delete: (id: number): AxiosPromise<any> => request({
        url: `/v1/admin/businessType/${id}`,
        method: 'delete'
    }),
}
